import type { FC } from 'react'

import { ArrowUpRight } from 'lucide-react'
import { Logo } from '@/components/generals/logo'

const columns = [
    {
        title: "Product",
        links: [
            { label: "Technology", href: '#power' },
            { label: "Lift and mast", href: '#lift' },
            { label: "Safety", href: '#safety' },
            { label: "Configure", href: '#configure' }
        ]
    },
    {
        title: "Why FORQ",
        links: [
            { label: "Industries", href: '#industries' },
            { label: "Savings calculator", href: '#savings' },
            { label: "Customer stories", href: '#reviews' },
            { label: "Service and finance", href: '#support' }
        ]
    },
    {
        title: "Help",
        links: [
            { label: "FAQ", href: '#faq' },
            { label: "Request a quote", href: '#quote' }
        ]
    }
]

export const Footer: FC = () => {
    return (
        <footer className='relative z-10 border-t border-white/[0.07] bg-background'>
            <div className='mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.4fr_2fr] lg:py-20'>
                <div className='max-w-sm'>
                    <Logo />
                    <p className='mt-5 text-sm leading-relaxed text-muted-foreground'>
                        Lithium electric forklifts engineered for longer shifts, safer floors and lower running costs.
                    </p>
                    <a
                        href='#quote'
                        className='group mt-7 inline-flex items-center gap-2 rounded-full border border-white/12 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:border-brand hover:text-brand'
                    >
                        Talk to our team
                        <ArrowUpRight className='size-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5' />
                    </a>
                </div>

                <div className='grid grid-cols-2 gap-10 sm:grid-cols-3'>
                    {columns.map(column => (
                        <nav key={column.title} aria-label={column.title}>
                            <p className='font-mono text-[11px] font-medium uppercase tracking-[0.18em] text-white/45'>
                                {column.title}
                            </p>
                            <ul className='mt-4 space-y-3'>
                                {column.links.map(link => (
                                    <li key={link.href}>
                                        <a href={link.href} className='text-sm text-white/75 transition-colors hover:text-brand'>
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    ))}
                </div>
            </div>

            <div className='border-t border-white/[0.07]'>
                <div className='mx-auto flex max-w-7xl flex-col gap-3 px-5 py-6 text-xs text-white/45 sm:flex-row sm:items-center sm:justify-between sm:px-8'>
                    <p suppressHydrationWarning>
                        © {new Date().getFullYear()} FORQ Electric Forklifts. All rights reserved.
                    </p>
                    <p>
                        Specifications are typical values and vary by configuration.
                    </p>
                </div>
            </div>
        </footer>
    )
}
